import { graphql } from "api/cms-website/generated";

export const TextWithCTAFiftyFiftyFragment = graphql(/* GraphQL */ `
    fragment TextWithCTAFiftyFiftyFragment on ComponentComponentsTextWithCtaFiftyFifty {
        id
        noMarginBottom
        textWithCtaText: text
        textWithCtaTitle: title
        textWithCtaCta: cta {
            ...ButtonFragment
        }
        icon {
            ...IconFragment
        }
        textColor {
            ...TextColorFragment
        }
        bgColor {
            ...BaseColorFragment
        }
    }
`);
